export default function ConnectionMethodSelector({
  methods,
  selectedMethod,
  onSelect,
  // The auth/connection methods this provider API supports (from the backend's
  // supported_auth_types). Falls back to the legacy single-value prop.
  supportedAuthTypes,
  supportedAuthType = "api_key"
}) {
  // Map auth_type to connection method ID
  const authTypeToMethodMap = {
    api_key: "apikey",
    mcp: "mcp",
    oauth: "oauth",
    webhook: "webhook",
    no_auth: "noauth"
  };

  const authTypes =
    Array.isArray(supportedAuthTypes) && supportedAuthTypes.length > 0
      ? supportedAuthTypes
      : [supportedAuthType];
  const supportedMethodIds = new Set(
    authTypes.map((t) => authTypeToMethodMap[t]).filter(Boolean)
  );
  if (supportedMethodIds.size === 0) supportedMethodIds.add("apikey");

  return (
    <div>
      <h3 className="text-base font-semibold text-gray-900 mb-2">
        Connection Method
      </h3>
      <p className="text-sm text-gray-600 mb-4">
        Choose how to authenticate with this service
      </p>
      <div className="grid grid-cols-4 gap-3">
        {methods.map((method) => {
          const Icon = method.icon;
          const isSupported = supportedMethodIds.has(method.id);
          const isDisabled = !isSupported;

          return (
            <button
              key={method.id}
              onClick={() => isSupported && onSelect(method.id)}
              disabled={isDisabled}
              className={`p-4 border rounded-lg flex flex-col items-center gap-2 transition-all ${
                isDisabled
                  ? "border-gray-200 bg-gray-50 cursor-not-allowed opacity-50"
                  : selectedMethod === method.id
                    ? "border-blue-500 bg-blue-50/50"
                    : "border-gray-200 hover:border-gray-300 hover:bg-gray-50"
              }`}
            >
              <div
                className={`rounded-lg p-2 ${isDisabled ? "bg-gray-200" : "bg-blue-200"}`}
              >
                <Icon className="w-5 h-5 text-gray-700" />
              </div>
              <span className="text-xs font-medium text-gray-900">
                {method.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
